import React, { useState, useEffect } from 'react';
import amaxLogo from "../../images/amaxLogo.png";
import arrowNext from "../../images/arrowNext.svg";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import API_URL from '../../api/API';



export const CoachStep2 = () => {
  const [email,setEmail] = useState('');
  const [password,setPassword] = useState('');
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);


  const navigate = useNavigate();

   
  useEffect(() => {
    // Restore data from sessionStorage
    const email_ = sessionStorage.getItem('email');
    const password_ = sessionStorage.getItem('password');

    if (email_) setEmail(email_);
    if (password_) setPassword(password_);
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!email || !password) {
      setError('Please enter all the details!');
      setMsg(null);
      return;
    }

    setError(null);
    setMsg(null);
    setLoading(true);

    try {
      const response = await fetch(API_URL.POST_CHECK_COACH_EMAIL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({email}),
      });

      const data = await response.json();
      setLoading(false);

      if (response.ok) {
        if(data.exists){
          setError(data.message);
          sessionStorage.setItem("email",email);
          sessionStorage.setItem("password",password);
        }
        else{
             // Success: Navigate to the next step
             sessionStorage.setItem("email",email);
             sessionStorage.setItem("password",password);
             navigate('/coach/register/step3');
            //setMsg("Success to proceed");
        }
     
      } else {
        // Display error returned by the server
        setError(data.error || 'An error occurred. Please try again.');
      }
    } catch (err) {
      setLoading(false);
      setError('Failed to connect to the server. Please try again.');
    }
  };


    return (
      <div className="p-[20px] bg-black h-dvh overflow-hidden">
        <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
          <Link to="/" className="size-[96px] lg:size-[166px]">
            <img src={amaxLogo} alt="logo" className="object-contain" />
          </Link>
          <div className="flex flex-col gap-[50px] w-full">
            <div className="flex flex-col gap-[15px]">
              <h1 className="text-white text-[40px] leading-[110%] font-li uppercase">
                LOGIN INFO
              </h1>
              <form onSubmit={handleSubmit} className="flex flex-col gap-[15px]">
                <input
                  type="email"
                  className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                  placeholder="Email*"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="password"
                  className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                  placeholder="Password*"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />


              {/* Display Loading Indicator */}
              {loading && (
                <p className="text-yellow-500 text-sm mt-2">
                  Processing request please wait...
                </p>
              )}


                   {/* Display Error Message */}
              {error && (
                <p className="text-red-500 text-sm mt-2">
                  {error}
                </p>
              )}

              {/* Display Success Message */}
              {msg && (
                <p className="text-green-500 text-sm mt-2">
                  {msg}
                </p>
              )}

              <button
                type="submit"
                className="bg-white size-[70px] rounded-full flex justify-center items-center hover:bg-white/50 transition-all duration-300 ml-auto mt-[10px]"
              >
                <img src={arrowNext} alt="arrow" className="object-contain" />
              </button>
              </form>
            </div>
        
          </div>
        </div>
      </div>
    );
  };
  